export const transform = ({
                              email,
                              username,
                              roles,
                              firstName,
                              lastName,
                              phone,
}) => (
  {
    username: username,
    firstName: firstName,
    lastName: lastName,
    number: phone,
    email: email,
    roles: roles && roles.map(({ roleID, rolename }) => ({ id: roleID, name: rolename }))
  }
);
